import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import parse from 'html-react-parser';

Messages.propTypes = {};

function Messages({ messages }) {
  return (
    <Box>
      {messages &&
        messages.map(({ messageContent }) => {
          return (
            messageContent &&
            messageContent.map((msg, index) => (
              <ul key={index}>
                <li>
                  <Typography
                    variant="body1"
                    style={{ wordWrap: 'break-word' }}
                  >
                    {parse(msg)}
                  </Typography>
                </li>
              </ul>
            ))
          );
        })}
    </Box>
  );
}

export default Messages;
